module.exports = __webpack_public_path__ + "img/report-7.59c224ab.jpg";